import '@/common';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import './animations';
import { CardSliderWidget } from '@/widgets/CardSliderWidget';
//import { createMainPageMapWidget } from '@/widgets/MapWidget';
import { createMapWidget } from '@/widgets/MapWidget';
import { JSONParser } from '@/utils/JSONParser';
import { createSliderWidget } from '@/widgets/SliderWidget';
import { BestOfferWidget } from '@/widgets/BestOfferWidget';

[...document.querySelectorAll<HTMLElement>('.best-offer-widget')].forEach((el) => {
    new BestOfferWidget(el);
});

[...document.querySelectorAll('.slider-widget')].forEach((el) => {
    createSliderWidget(el);
});

gsap.registerPlugin(ScrollTrigger);
const parser = new JSONParser('main-page');

window.addEventListener('load', () => {
    document.body.classList.add('main-page-ready');

    [...document.querySelectorAll<HTMLElement>('.card-slider')].forEach((el) => {
        const options = el.getAttribute('data-swiper-options');
        new CardSliderWidget(el, options ? parser.parse(options) : undefined);
    });
});

/*const mapIgnition = ScrollTrigger.create({
    trigger: '#main-page-map-widget',
    onEnter(scrollTrigger) {
        const el = scrollTrigger.trigger as HTMLElement;
        const settings: unknown = JSON.parse(el.getAttribute('data-settings') || '');
        const modalData: unknown = JSON.parse(el.getAttribute('data-modal-data') || '');
        createMainPageMapWidget(el, settings, modalData);
        mapIgnition?.disable();
    },
});*/

const mapIgnition = ScrollTrigger.create({
    trigger: '#map-widget',
    onEnter(scrollTrigger) {
        createMapWidget(scrollTrigger.trigger!);
        mapIgnition?.disable();
    },
});
